export const GET_MY_RUNS = `
  query GetMyRuns($organizationId: String!, $limit: Int, $nextToken: String) {
    getMyRuns(
      organizationId: $organizationId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        runSettings
        organizationId
        status
        createdAt
        updatedAt
        stepIds
        initiatedBy
        name
        description
        atStep
        totalSteps
        engineInProgress
      }
      nextToken
    }
  }
`;
